<template>
  <delivered_mr-component>
    <b-row class="mt-2 mb-2">          
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
              <option :value="false">Asc</option> <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>             
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>            
    </b-row> 
    <b-row>
      <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
      <b-col sm="12">
      <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy"> 
          <template slot="shippingid" slot-scope="row">
          {{ row.item.shippingid}}
         <span class="badge badge-primary badge-pill" v-if="row.item.orderflow=='Reverse'">{{ row.item.orderflow}}</span>
         <span class="badge badge-primary badge-pill"  v-if="row.item.istrybuy=='1' && row.item.orderflow !='Reverse'">istrybuy</span>
         </template>
          <template slot="userinfo" slot-scope="row">
                 {{ row.item.deliveryagentfirstname}} {{ row.item.deliveryagentlastname}}
          </template>  
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>   
      </b-table> 
    </b-col>
      <b-col md="6" class="my-1" v-if="this.totalRows > 10">
        <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
      </b-col> 
    </b-row> 
  </delivered_mr-component>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      result:[],
      items:[],
      isBusy: false,
      fields: [
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'userinfo', label: 'SR Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},               
       
          { key: 'lastmodifieddate', label: 'Date', sortable: true }
       
      ],
      outlined: true,
      totalRows: 0,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  created: function() {
    this.delivered()
  },
  mounted () {
  },
 computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  methods: {
     info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    delivered(){
      this.isBusy = true;
      let userData =localStorage.getItem("userData");
      let userInfo= JSON.parse(userData);
    let pincode= JSON.stringify(userInfo.pickuplocationpincode);
      let obj={
        pickuplocationpincode:pincode,
        status:"Delivered"
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getstatuswiselist`,obj)
       .then((response) => {
         this.isBusy = !this.isBusy;
         if(response.body.returnmsg==="successful"){
           this.result = response.body.returnvalue;
           this.items  = response.body.returnvalue;
           this.totalRows = response.body.returnvalue.length
         }
         else{
           this.items  = [];
           this.totalRows = 0
         }
        }).catch((ex) => {
           console.log('error', ex)
         })
    }
  }
}
</script>

